import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import CustomSelect from "../shared/custom-components/select";
import Search from "../shared/custom-components/search";
import { cleanIputText } from "./functions";

const FilterComponentProvider = ({ filter, searchFnc }) => {
  const [state, setState] = useState({
    selectedValue: filter[0].property,
    searchValue: "",
  });

  const { t } = useTranslation();

  const onChange = (item) =>
    setState({ ...state, selectedValue: item.property });

  const searchChange = ({ target }) => {
    if (target.value == "") searchFnc(0, "");
    setState({
      ...state,
      searchValue: cleanIputText(target.type, target.value),
    });
  };

  const handleKey = (event) => {
    if (event.key == "Enter") search();
  };

  const search = () => {
    const { selectedValue, searchValue } = state;
    if (selectedValue != "" && searchValue != "")
      searchFnc(selectedValue, searchValue);
  };

  return (
    <div className="filter-bar-provider">
      <div className="filter">
        <CustomSelect
          id="filtersBar"
          className={`filter-search`}
          placeholder={t("general.filters.placeholder")}
          items={filter}
          handleChange={onChange}
        />
      </div>
      <Search
        id="search-field"
        name="searchValue"
        placeholder={t("general.filters.search")}
        className="Input__input Search__input"
        onChange={searchChange}
        onSearchClick={search}
        onKeyDown={handleKey}
        value={state.searchValue}
      />
    </div>
  );
};

FilterComponentProvider.propTypes = {
  filter: PropTypes.array.isRequired,
  searchFnc: PropTypes.func.isRequired,
};

export default FilterComponentProvider;
